import * as MeteringUploadConstants from "../MeteringUpload/MeteringUploadConstants";
import * as CommonConstants from "Common/constants/commonConstants";
import {
    STATUS_FAILURE,
    STATUS_SUCCESS,
  } from "Common/constants/commonConstants";
import { uploadMeterZip } from "./MeteringUploadAction";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  meterZipUploadHistoryList: [],
  meterModelList: [],
  meterZipUploadSuccessMessage: "",
  meterZipUploadErrorMessage: "",
  meterZipUploadRequestStatus: CommonConstants.STATUS_SUCCESS,
  isMeterZipUploadSuccessPopup: false,
  isMeterZipUploadErrorPopup: false,
  meterHistoryRequestStatus: CommonConstants.STATUS_PENDING,
  meterUploadsInstances: [],
  meterUploadsSerialNumbers: [],
  meterZipUploadsHistoryHasMore : true,
  zipFileSizeFromConfig : "",
};

export default function MeteringUploadReducer(state = initialState, action) {
  switch (action.type) {
    case MeteringUploadConstants.LOAD_METER_MODEL_LIST: {
      return assign({}, state, {
        meterModelList: action.newState.meterModelList,
      });
    }
    case MeteringUploadConstants.METER_UPLOAD_INSTANCE_LIST_AND_ZIP_SIZE_LIMIT: {
      return assign({}, state, {
        zipFileSizeFromConfig: action.newState.zipFileSizeFromConfig,
        meterUploadsInstances: action.newState.meterUploadsInstances,
        meterUploadsSerialNumbers: action.newState.meterUploadsSerialNumbers,
      });
    }
    case MeteringUploadConstants.EMPTY_METER_ZIP_UPLOAD_HISTORY: {
      return assign({}, state, {
        meterZipUploadHistoryList:action.newState.meterZipUploadHistoryList,
      });
    }
    case MeteringUploadConstants.LOAD_METER_HISTORY_REQUEST: {
      const newState = {
        ...state,
        meterHistoryRequestStatus: CommonConstants.STATUS_PENDING,
        meterZipUploadHistoryList: action.onApplyClick ? [] : state.meterZipUploadHistoryList
      };
      return assign({}, state, newState);
    }
    case MeteringUploadConstants.LOAD_METER_HISTORY_SUCCESS: {
      const newState = {
        ...state,
        meterHistoryRequestStatus: CommonConstants.STATUS_SUCCESS,
        meterZipUploadHistoryList: action.newState.onApplyClick ? action.newState.meterZipUploadHistoryList : [...state.meterZipUploadHistoryList, ...action.newState.meterZipUploadHistoryList],
        meterZipUploadsHistoryHasMore : action.newState.meterZipUploadHistoryList?.length == 10 ? true : false
        
      };
      return assign({}, state, newState);
    }
    case MeteringUploadConstants.LOAD_METER_HISTORY_ERROR: {
      const newState = {
        ...state,
        meterHistoryRequestStatus: CommonConstants.STATUS_FAILURE,
      };
      return assign({}, state, newState);
    }
    case MeteringUploadConstants.UPLOAD_METER_ZIP_REQUEST: {
      const newState = {
        ...state,
        meterZipUploadRequestStatus: CommonConstants.STATUS_PENDING,
      };
      return assign({}, state, newState);
    }
    case MeteringUploadConstants.UPLOAD_METER_ZIP_SUCCESS: {
      const newState = {
        ...state,
        meterZipUploadRequestStatus: STATUS_SUCCESS,
        isMeterZipUploadSuccessPopup: true,
        isMeterZipUploadErrorPopup: false,
        meterZipUploadSuccessMessage: action.payload,
      };
      return assign({}, state, newState);
    }
    case MeteringUploadConstants.METER_ZIP_UPLOAD_ERROR: {
      const newState = {
        ...state,
        meterZipUploadRequestStatus: STATUS_FAILURE,
        isMeterZipUploadSuccessPopup: false,
        isMeterZipUploadErrorPopup: true,
        meterZipUploadErrorMessage: action.payload,
      };
      return assign({}, state, newState);
    }
    case MeteringUploadConstants.CLOSE_SUCCESS_MESSAGE_POPUP:
      return assign({}, state, {
        isMeterZipUploadSuccessPopup: false,
      });
    case MeteringUploadConstants.CLOSE_ERROR_MESSAGE_POPUP:
      return assign({}, state, {
        isMeterZipUploadErrorPopup: false,
      });
    case MeteringUploadConstants.OPEN_ERROR_MESSAGE_POPUP_FILE_TYPE:
      return assign({}, state, {
        isMeterZipUploadErrorPopup: true,
        meterZipUploadErrorMessage: "File type should be Zip",
      });
    case MeteringUploadConstants.OPEN_ERROR_MESSAGE_POPUP_FILE_SIZE:
      return assign({}, state, {
        isMeterZipUploadErrorPopup: true,
        meterZipUploadErrorMessage: "Zip file size should be less than 1 MB",
      });

    default:
      return state;
  }
}
